module.exports = __webpack_public_path__ + "static/media/icon-dash-genetic.706ac74a.png";